var map = {
	"./a_sound.mp3": 63695,
	"./b_sound.mp3": 77324,
	"./c_sound.mp3": 18645,
	"./d_sound.mp3": 70554,
	"./e_sound.mp3": 10963,
	"./f_sound.mp3": 28512,
	"./g_sound.mp3": 77017,
	"./h_sound.mp3": 93342,
	"./i_sound.mp3": 63047,
	"./j_sound.mp3": 53700,
	"./k_sound.mp3": 31885,
	"./l_sound.mp3": 75282,
	"./m_sound.mp3": 24875,
	"./n_sound.mp3": 12792,
	"./o_sound.mp3": 5713,
	"./p_sound.mp3": 32342,
	"./q_sound.mp3": 94463,
	"./r_sound.mp3": 43580,
	"./s_sound.mp3": 96229,
	"./t_sound.mp3": 23242,
	"./u_sound.mp3": 16611,
	"./v_sound.mp3": 16144,
	"./w_sound.mp3": 11785,
	"./x_sound.mp3": 94702,
	"./y_sound.mp3": 17367,
	"./z_sound.mp3": 51412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44438;